import React from 'react';
import { Button, Layout } from 'antd';
import { useDispatch } from 'react-redux';
import { logoutInitiate } from '../../config/Redux/action';

const { Header} = Layout;

const Headers = (props) => {
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logoutInitiate());
    window.location.assign('/login');
  };
  return (
    <Header
      className='site-layout-background'
      style={{ padding: 0 }}
      onClick={props.toogle}
    >
      {React.createElement(
        props.collapsed ? props.MenuUnfoldOutlined : props.MenuFoldOutlined,
        { className: 'menu-dashboard' },
      )}
      <Button style={{position:'absolute', right:20, top:15, borderRadius:'6px'}} className='btn-logout' onClick={handleLogout} type='primary' danger>
        Logout
      </Button>
    </Header>
  );
};

export default Headers;
